export default __webpack_public_path__ + "static/20250627-3b807e18db89ac39c00049a4a2bc735d.png";